<div class="wrapper">
  <div class="table-container">
    <table class="table table-sm">
      <thead>
      <tr>
        <th style="width: 50%;">
          {{'VIVO name' | translate}}
        </th>
        <th style="width: 50%;">
          {{'REGO mapping' | translate}}
        </th>
      </tr>
      </thead>
      <tbody *qmLoading="loading">
      <!-- TODO: needs more meaningful ordering -->
      <ng-template ngFor let-asset [ngForOf]="assetList | qmOrderBy:'name'">
        <tr>
          <td style="width: 50%;">
            <span ngbTooltip="{{asset._id}} {{asset.textSearchIndex}}">
              {{getAssetName(asset)}}
            </span>
          </td>

          <td style="width: 50%;">
              <span *ngIf="asset._id !== editLink; else editor;" (click)="setEditLink(asset._id);">
                <ng-container *ngIf="linkingListVivo[asset._id];">
                  {{getTitle(linkingListVivo[asset._id].regoId)}}
                </ng-container>
                <ng-container *ngIf="!linkingListVivo[asset._id];">
                  {{'Asset not mapped' | translate}}
                </ng-container>
              </span>
          </td>
        </tr>
      </ng-template>
      </tbody>
    </table>
    <div style="width: 100%; margin-top: 0.2em;" class="d-flex justify-content-center">
      <ngb-pagination
        (pageChange)="turnPage($event)"
        [(page)]="pagination.page"
        [pageSize]="pagination.limit"
        [maxSize]="10"
        [collectionSize]="pagination.total"></ngb-pagination>
    </div>
  </div>
</div>
<ng-template #rt let-r="result" let-t="term">
  <ngb-highlight [result]="r"></ngb-highlight>
</ng-template>

<ng-template #editor>
  <div class="d-flex">
    <div style="flex-grow: 1;">
      <input id="typeahead-format" type="text"
             [(ngModel)]="currentLink"
             [ngbTypeahead]="search"
             [resultFormatter]="getMapObjectTitle"
             [inputFormatter]="getMapObjectTitle"
             container="body"
             class="form-control form-control-sm" />
    </div>
    <div style="margin: 0 10px;">
      <a [attr.data-btnId]="getElementId('saveLink')" class="text-success" (click)="saveLink();">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#check"></use>
        </svg>
      </a>
      <a [attr.data-btnId]="getElementId('setEditLink')" class="text-info" (click)="setEditLink('');">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#times"></use>
        </svg>
      </a>
      <a [attr.data-btnId]="getElementId('unLink')" class="text-info" (click)="unLink()">
        <svg class="svg-inline--fa fa-w-20">
          <use xlink:href="#trash"></use>
        </svg>
      </a>
    </div>
  </div>
</ng-template>

<i class="far fa-check" data-fa-symbol="check"></i>
<i class="far fa-times" data-fa-symbol="times"></i>
<i class="far fa-trash-alt" data-fa-symbol="trash"></i>
